import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Ref, ref, createRef } from "lit/directives/ref.js";
import { emptyToUndefined, getUTMTagsFromURL } from "./utils";

const nisUrl = "https://nis2.nahtamatudloomad.ee";

@customElement("nl-newsletter")
// @ts-ignore - typescript doesn't like that this class is not used
class Newsletter extends LitElement {
  @property()
  campaign: string = "ulduudiskiri";

  @property()
  successMessage: string = "Oled uudiskirja lisatud. Aitäh!";

  private firstNameRef: Ref<HTMLInputElement> = createRef();
  private lastNameRef: Ref<HTMLInputElement> = createRef();
  private phoneRef: Ref<HTMLInputElement> = createRef();
  private emailRef: Ref<HTMLInputElement> = createRef();
  private message: string | undefined = undefined;

  async submit(event: Event) {
    event.preventDefault();
    const form = this.shadowRoot?.querySelector("form")!;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const contact = {
      firstName: this.firstNameRef.value?.value,
      lastName: this.lastNameRef.value?.value,
      email: this.emailRef.value?.value,
      phone: emptyToUndefined(this.phoneRef.value?.value),
      ...getUTMTagsFromURL(),
    };

    const res = await fetch(
      `${nisUrl}/api/smaily/campaign/${this.campaign}/contact/register`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(contact),
      }
    );
    if (res.ok) {
      this.message = this.successMessage;
    } else {
      this.message = "Esines viga. Palun proovi hiljem uuesti.";
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: "signup" });
    }
    this.requestUpdate();
  }

  static get styles() {
    return [
      css`
        :host {
          padding: 15px;
          width: 100%;
          font-family: "Montserrat", sans-serif;
          font-size: 12pt;
          box-sizing: border-box;
          --default-height: 40px;
        }

        form {
          display: flex;
          flex-direction: column;
          justify-items: start;
          align-items: center;
          color: black;
        }

        .submit {
          background: #38dabd;
          border: 0;
          padding: 0.8rem 1rem;
          font-size: 1.2rem;
          height: var(--default-height);
          cursor: pointer;
          font-weight: bold;
          transition: all 0.2s ease;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          color: white;
          text-transform: uppercase;
          min-width: 150px;
          max-width: 200px;
          margin-top: 30px;
        }

        .submit:hover {
          background: #5aceb9;
        }

        .input {
          width: 100%;
          line-height: 30pt;
          font-size: 14pt;
          background-color: #fff;
          border-color: #ddd;
          border-style: solid;
          border-width: 0 0 1px 0;
          color: black;
          padding: 5px 20px;
          box-sizing: border-box;
          transition: all 0.2s ease;
        }

        .input:focus {
          outline: none;
          background-color: #f5f5f5;
        }

        ::placeholder {
          opacity: 0.3;
        }

        .message {
          text-align: center;
          font-size: 22pt;
        }
      `,
    ];
  }

  render() {
    return html`
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap"
        rel="stylesheet"
      />

      ${
        this.message === undefined
          ? html`
              <form>
                <input
                  placeholder="Eesnimi"
                  type="text"
                  class="input"
                  required
                  ${ref(this.firstNameRef)}
                />
                <input
                  placeholder="Perekonnanimi"
                  type="text"
                  class="input"
                  required
                  ${ref(this.lastNameRef)}
                />
                <input
                  placeholder="Telefoninumber"
                  type="text"
                  class="input"
                  ${ref(this.phoneRef)}
                />
                <input
                  placeholder="E-posti aadress"
                  type="email"
                  class="input"
                  required
                  ${ref(this.emailRef)}
                />
                </div>

                <button class="submit green-button" @click=${(e: Event) =>
                  this.submit(e)}>
                  Liitun
                </button>
            `
          : html`<div class="message">${this.message}</div>`
      }
      </form>
    `;
  }
}
